module.exports = __webpack_public_path__ + "img/lvshihuijian.7447fdfd.png";